module.exports = __webpack_public_path__ + "static/media/2DGACM16.4552eb8a.jpg";